/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useModal } from '@atlaskit/modal-dialog';
import { ModalContent } from './ModalContent';
var Modal = function Modal(_ref) {
  var formatting = _ref.formatting;
  var _useModal = useModal(),
    onClose = _useModal.onClose;
  return jsx(ModalContent, {
    formatting: formatting,
    onClose: onClose
  });
};
export default Modal;